module.exports = __webpack_public_path__ + "static/img/f6.463a15c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ui3/f6.png
// module id = vQMj
// module chunks = 1